import React, { useEffect } from 'react';

import classNames from 'classnames';
import { Fade } from 'react-awesome-reveal';
import { View } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Container, WysiwygField, CoreLink } from '../../../../components';
import { SCREEN_MOBILE, SCREEN_TABLET, SCREEN_NORMAL, SCREEN_WIDE } from '../../../../config/constants';

import './style.scss';
import '../../../Paragraph/QuestionsOverview/QuestionsOverviewItem/style.scss';

const NodeKPQuestionPageFull = ({ entity, className }) => {

  const classes = classNames(className, 'KPQuestionPage', {
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const { t } = useTranslation();
  const entityId = entity.getIn(['nid', 0, 'value']);
  const externalFacts = entity.get('field_external_facts');
  const typeOfQuestion = entity.getIn(['field_type_of_question', 0, 'target_id']);
  const typeOfQuestionEntity = entity.getIn(['field_type_of_question', 0, 'entity']);
  const typeOfQuestionLink = typeOfQuestionEntity.getIn(['field_link', 0, 'alias'], typeOfQuestionEntity.getIn(['field_link', 0, 'uri']));
  const externalFactsTitle = entity.getIn(['field_external_facts_title', 0, 'value'], t('kp.external_facts_title'));
  const title = entity.getIn(['field_content_title', 0, 'value']);
  let semanticTitle = title.replace('<p', '<h1');
  semanticTitle = semanticTitle.replace('</p>', '</h1>');

  const renderQuestionTypeImage = () => (
    <Image
      src={{
        [SCREEN_MOBILE]: typeOfQuestionEntity.getIn(['field_image', 0, 'styles', 'ratio_16_9_sm']),
        [SCREEN_TABLET]: typeOfQuestionEntity.getIn(['field_image', 0, 'styles', 'ratio_16_9_xs']),
        [SCREEN_NORMAL]: typeOfQuestionEntity.getIn(['field_image', 0, 'styles', 'ratio_16_9_sm']),
        [SCREEN_WIDE]: typeOfQuestionEntity.getIn(['field_image', 0, 'styles', 'ratio_16_9_md']),
      }}
      includeWebP
    />
  );

  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="KPQuestionPage__hero">
        <Container>
          <Fade triggerOnce bottom distance="50px" duration={500}>
            <WysiwygField className="KPQuestionPage__title page-header" html={semanticTitle} />
            {entity.getIn(['body', 0, 'value']) && (
              <WysiwygField
                property="schema:text"
                className="KPQuestionPage__body"
                html={entity.getIn(['body', 0, 'value'], '')}
              />
            )}
            {entity.getIn(['field_body_answers', 0]) && (
              <WysiwygField
                property="schema:text"
                className="KPQuestionPage__body__answers"
                html={entity.getIn(['field_body_answers', 0, 'processed'], '')}
              />
            )}
          </Fade>
        </Container>
      </div>

      <Container className="KPQuestionPage__answersContainer">
        <div className="KPQuestionPage__answersContainer__answers">
          <Fade triggerOnce bottom distance="50px" duration={500}>
            <View id="kp_answers" display="block_1" args={[entityId]} />
          </Fade>
        </div>

      </Container>
      {externalFacts && (
        <Container>
          <div className="KPQuestionPage__external-facts">
            <h3>{externalFactsTitle}</h3>

            <div className="KPQuestionPage__external-facts__wrapper">
              {entity.getIn(['field_external_facts_body']).size > 0 && (
                <WysiwygField
                  property="schema:text"
                  className="KPQuestionPage__external-facts__body"
                  html={entity.getIn(['field_external_facts_body', 0, 'processed'], '')}
                />
              )}
              <div className="KPQuestionPage__external-facts__wrapper__facts">
                {externalFacts.map((externalFact, index) => {
                  const title = externalFact.getIn(['entity', 'field_link', 0, 'title']);
                  const description = externalFact.getIn(['entity', 'field_link_description', 0, 'value']);
                  const link = externalFact.getIn(['entity', 'field_link', 0, 'alias']) || externalFact.getIn(['entity', 'field_link', 0, 'uri']);

                  return (
                    <CoreLink key={index} to={link}>
                      <div className="KPQuestionPage__external-facts__fact">
                        <p className="KPQuestionPage__external-facts__fact__title">{title}</p>
                        <p className="tiny">{description}</p>
                        <i className="icon icon-link" />
                      </div>
                    </CoreLink>
                  );
                })}
              </div>
            </div>
          </div>
        </Container>
      )}
      <Container>
        <div className="row">
          <div className="col-12">
            <h2>{t('kp.relevant_questions')}</h2>
          </div>
        </div>
        <div className="KPQuestionPage__linked-questions">
          <div className="QuestionsOverviewItem__content">
            <div className="QuestionsOverviewItem__questions">
              <View id="kp_questions" display="block_2" args={[entityId, typeOfQuestion]} />
            </div>
            <div className="QuestionsOverviewItem__image">
              {typeOfQuestionLink ? (
                <CoreLink to={typeOfQuestionLink}>
                  {renderQuestionTypeImage()}
                </CoreLink>
              ) : (renderQuestionTypeImage())}
            </div>
          </div>
        </div>
      </Container>
    </article>
  );
};

export default NodeKPQuestionPageFull;
